<!--
 * @Descripttion: 图片组件
 * @Author: zenghua.wang
 * @Date: 2021-12-06 10:24:02
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 16:54:53
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-if="!option.hide"
  >
    <img
      :style="styleImage"
      v-if="option.source"
      :src="`${FDFS_WEB_SERVER_URL + option.source}`"
      :class="{'drag-image-rotate' : option.animation}"
      draggable="false"
    />
    <i
      v-else
      class="xa-icon xa-icon-picture drag-image-placeholder"
    ></i>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import {
  component,
  FDFS_WEB_SERVER_URL
} from '@/dragComponents/model/default.js'
import { setPx } from '@/dragComponents/utils'

export default {
  name: 'drag-image',
  mixins: [bem],
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 100
    },
    height: {
      type: [Number, String],
      default: 100
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      FDFS_WEB_SERVER_URL: FDFS_WEB_SERVER_URL
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: setPx(this.width),
          height: setPx(this.height),
          lineHeight: setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleImage() {
      return Object.assign(
        (() => {
          if (this.option.animation) {
            return {
              animationDuration: `${this.option.animationTime / 1000}s`
            }
          }
          return {}
        })(),
        {
          width: setPx(this.width),
          height: setPx(this.height),
          borderRadius: setPx(this.option.borderRadius),
          opacity: this.option.opacity
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.drag-image {
  overflow: hidden;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;

  &-rotate {
    animation: rotateAnimation 0s linear infinite;
  }

  &-placeholder {
    font-size: 50px;
    color: rgb(212, 205, 205);
  }
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
